import { render } from "./icon-close.vue?vue&type=template&id=5d30ccca"
import script from "./icon-close.vue?vue&type=script&lang=js"
export * from "./icon-close.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__